import { render, staticRenderFns } from "./TwPreviewJsonParent.vue?vue&type=template&id=6b04c7e3&"
import script from "./TwPreviewJsonParent.vue?vue&type=script&lang=js&"
export * from "./TwPreviewJsonParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports